var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutBoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BCE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10C22.3682 10 22.6667 10.2985 22.6667 10.6667V21.3377C22.6667 21.7035 22.3631 22 22.0055 22H9.99453C9.62937 22 9.33333 21.7034 9.33333 21.3377V20.6667H21.3333V12.8667L16 17.6667L9.33333 11.6667V10.6667C9.33333 10.2985 9.63181 10 10 10H22ZM13.3333 18V19.3333H8V18H13.3333ZM11.3333 14.6667V16H8V14.6667H11.3333ZM21.0439 11.3333H10.9561L16 15.8729L21.0439 11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutBoundIcon);
export default __webpack_public_path__ + "static/media/OutBoundIcon.1af31d3319bca1f70cc3afa10dd0a2ef.svg";
export { ForwardRef as ReactComponent };